import React from 'react'
import {connect} from 'react-redux'
//import {fetchTowns} from '../actions/townsActions'
import {fetchReportRefunds, setReportRefundsInfoText} from '../actions/reportActions'
import { Container, Row, Col, Button, Form, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import moment from 'moment';
//import 'moment/locale/pl';
//import TownsSelect from '../components/TownsSelect'

const mapStateToProps = state => {  
  return {
    filter: state.report.refundsFilter,    
//    townsFrom: state.towns.allTowns,
//    townsTo: state.towns.toTowns,
//    townFrom: state.towns.fromTown,
//    townTo: state.towns.toTown,
    agentLogin: state.user.agentLogin,
    companies: state.user.agentCompanies,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {  
//    onGetAllTowns: (ownProps) => {          
//      dispatch(fetchTowns(ownProps.agentLogin))
//    },
//    onGetToTowns: (ownProps) => {
//      dispatch(fetchTowns(ownProps.agentLogin, ownProps.townFrom))      
//    },
    onFetchReport: (ownProps, apiRequest) => {
      dispatch(setReportRefundsInfoText("Wyszukiwanie ..."))
      dispatch(fetchReportRefunds(apiRequest))      
    },
  }
}

// const S_CRITERIA = [
//   { value: 'operation', label: 'data operacji', className: 'criteria' },
//   { value: 'course', label: 'data kursu', className: 'criteria' },
//   { value: 'id', label: 'id', className: 'criteria' },
// ];

class ReportFilter extends React.Component{
  constructor (props) {
    super(props)  
    
    this.state = {
      formClass: props.formClass || 'filterForm',
      
      agentLogin: props.agentLogin,
      
      fromDate: moment(),
      toDate: moment(),
      company: null,
      
//      onGetAllTowns: props.onGetAllTowns,
//      onGetToTowns: props.onGetToTowns,
      onFetchReport: props.onFetchReport,
    };
    if (this.props.filter){
      this.state={
        ...this.state,
        fromDate: moment(this.props.filter.dateFrom),
        toDate: moment(this.props.filter.dateTo),        
      }

      if (this.props.filter.company)
        this.state={
          ...this.state,
          company: this.props.filter.company,
        }
    }
      
    this.handleChangeFromDate = this.handleChangeFromDate.bind(this);
    this.handleChangeToDate = this.handleChangeToDate.bind(this);
    this.handleInputChange=this.handleInputChange.bind(this);
    this.handleChangeCompany=this.handleChangeCompany.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);       
  }

  handleChangeFromDate(date) {
    var toDate=this.state.toDate;
    if (date>toDate)
      toDate=date
    this.setState({
      fromDate: date,
      toDate
    });
  }
  handleChangeToDate(date) {
    var fromDate=this.state.fromDate;
    if (date<fromDate)
      fromDate=date
    this.setState({
      toDate: date,
      fromDate
    });
  }
  handleChangeCompany = (selectedOption) => {    
    this.setState({ 
      company: (selectedOption ? selectedOption.value : null),
    })
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    //console.log(name + ' -> ' + value);
  }
  
  handleSubmit(event) {
    event.preventDefault();
    this.saveStateToLocalStorage();
    let reportReq={
      agent: this.props.agentLogin,

      dateFrom: this.state.fromDate.format('YYYY-MM-DD'),
      dateTo: this.state.toDate.format('YYYY-MM-DD'),      
    }
    if (this.state.company)
      reportReq={...reportReq, company: this.state.company}
      
    //console.log("Search Request", searchReq)
    this.state.onFetchReport(this.state, reportReq)
  }
  
  componentDidMount() {
    //fetchTowns(this.state.agentLogin)
    //this.onGetAllTowns()
    //this.state.onGetAllTowns(this.state);
  }
  componentWillUnmount(){
    this.saveStateToLocalStorage();    
  }
  saveStateToLocalStorage(){
//    localStorage.setItem('townFrom', this.state.townFrom);
//    localStorage.setItem('townTo', this.state.townTo);
  }
  renderCompanies() {    
      return (
        <Col xs="8" sm="3" lg="2">
          <Label>Przewoźnik:</Label>        
          <Select
            id="state-select"              
            autoFocus
            options={this.props.companies.map(pos => ({value: pos.loginName, label: pos.shortName}))}
            name="criteria"              
            value={this.state.company}
            placeholder="Wybierz przewoźnika"
            onChange={this.handleChangeCompany}              
            openOnClick={true}
            searchable={true}
            clearable={true}
          />
        </Col>
      )    
  }
  render() {
    //console.log(townsFrom, this.state.townsFrom)
    return (  
      <Container fluid={true} className={this.state.formClass}>
      <Form>      
        <Row className="align-items-center">
          <Col xs="12" sm="3">
            <Label>Data początkowa:</Label>
            <DatePicker 
                className="form-control"
                selected={this.state.fromDate}
//                dateFormat="DD-MM-YYYY"                   
                minDate={moment().add(-12, 'month')}
                maxDate={moment()}
                onChange={this.handleChangeFromDate}               
            />
          </Col>
          <Col xs="12" sm="3">
            <Label>Data końcowa:</Label>
            <DatePicker 
                className="form-control"
                selected={this.state.toDate}
//                dateFormat="DD-MM-YYYY"                   
                minDate={moment().add(-12, 'month')}
                maxDate={moment()}
                onChange={this.handleChangeToDate}               
            />
          </Col>

          {this.renderCompanies()}
          
          <Col xs="12" sm="auto" className="ml-sm-auto">            
            <Button color="danger" size="lg" onClick={this.handleSubmit}>Szukaj zwrotów</Button>   
          </Col>
        </Row>          
      </Form>  
      </Container>
    )
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportFilter)    


// WEBPACK FOOTER //
// ./src/containers/RefundsFilter.js